/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'dvsn-form-builder',
    label: 'dvsn-form-builder.cms-block.label',
    category: 'form',
    component: 'sw-cms-block-dvsn-form-builder',
    previewComponent: 'sw-cms-preview-dvsn-form-builder',
    defaultConfig: {
        marginBottom: '0',
        marginTop: '0',
        marginLeft: '0',
        marginRight: '0',
    },
    slots: {
        content: 'dvsn-form-builder',
    },
});
